import React from 'react';
import './ITSoftware.css';

function RealEstate() {
  return (
    <div className="service-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/realestate&infrastructure1.png')" }}
      >
        <div className="hero-text-container">
          <h1>Real Estate & Infrastructure</h1>
          <p>Structured financial advisory and regulatory guidance for realty and infra ventures</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content">
        <div className="content-left">
          <h2>Building Stronger Financial Foundations</h2>
          <p>We support real estate developers, EPC firms, and infra SPVs in managing financial planning and project viability.</p>
          <p>Our services span RERA compliance, joint development agreements, capital structuring, and tax optimization.</p>
          <p>Navigate project approvals, land acquisition, and investor readiness with dedicated sector expertise.</p>
          <p>We also assist with REIT structuring, commercial leasing strategies, and construction tax compliance.</p>
        </div>
        <div className="content-right">
          <img src="/images/real_estate.jpg" alt="Real Estate & Infrastructure" />
        </div>
      </section>
    </div>
  );
}

export default RealEstate;
